export default {
  programming: {
    languages: {
      good: ['TypeScript', 'Go', 'C / C++'],
      ok: ['Rust', 'Python'],
    },
    space: [4],
    list: [
      'Praktische Kenntnisse der Sprachen <b>Go</b>, <b>Rust</b> und <b>C/C++</b> in der allgemeinen, anwendungsbezogenen, objektorientierten, Netzwerk- und <b>Embedded</b>-Programmierung.',
      'Integration von <b>KI</b> mit anderen Anwendungsschichten. Praktische Kenntnisse in den Bereichen <b>Maschinelles Lernen</b> und <b>Deep Learning</b>.',
      'Programmierung von Desktop- und Webanwendungen mit <b>Vue</b>-Technologie und <b>TypeScript</b>.',
      'Datenbankmanagement - Erfahrung mit <b>SQLite</b>, <b>MongoDB</b> und <b>MySQL</b>. Grundlagen von DevOps, einschließlich <b>Google Cloud</b>.',
      'Fähigkeit zur <b>Modellierung physikalischer Prozesse</b> und zur Durchführung von <b>Computersimulationen</b>, einschließlich der Nutzung von <b>ML</b>.',
      'Kenntnisse in Methoden der computergestützten Werkstofftechnik wie <b>Monte-Carlo</b>, <b>Molekulardynamik</b> oder <b>DFT</b>.',
    ],
  },
  technical: {
    space: [3, 6],
    list: [
      'Wissen über <b>Betriebssysteme</b> und <b>Computerarchitektur</b>. Arbeiten in <b>Linux / UNIX</b>-Systemen, einschließlich <b>Shell</b>-Kenntnissen.',
      'Grundkenntnisse der <b>Teleinformatik</b> in Bereichen wie Computernetzwerken und Datensicherheit.',
      'Praktisches Wissen im Bereich der <b>Telekommunikation</b>. Konfiguration von Installationen und Erstellung von Internetsystemen.',
      'Bedienung von Computer- und Messgeräten. <b>Computerisierung von Messungen</b> in <b>LabVIEW</b>.',
      'Diagnose und Reparatur von <b>elektronischen Geräten</b>. Fähigkeit, <b>elektronische Schaltpläne</b> zu lesen.',
      'Grundlagen der Bedienung und Programmierung von <b>AVR</b>-Mikrocontrollern und eingebetteten Systemen, insbesondere <b>Arduino</b>.',
      'Fähigkeit, <b>technische Zeichnungen</b> zu erstellen und zu lesen sowie 2D- und 3D-Schaltpläne in <b>NX</b> zu erstellen.',
      'Erfahrung in fortschrittlichen Materialforschungsmethoden wie: <b>XRD, DSC, DTA / TGA, TMA, XAS</b> sowie <b>Spektroskopie</b>: Absorptions-, Lumineszenz-, Impedanz- oder Infrarotspektroskopie.',
    ],
  },
  science: {
    space: [5],
    list: [
      'Umfassende Kenntnisse der Prozesse und Technologien, die in der <b>Physik und Chemie fortschrittlicher Materialien</b> verwendet werden.',
      'Erfahrung in der <b>Physik ionischer Prozesse</b>, insbesondere in Energie<b>verarbeitungs- und Speichertechnologien</b>.',
      'Wissen über moderne Anwendungen der <b>Halbleiterstrukturphysik</b> und <b>Festkörperelektronik</b>.',
      'Praktische Kenntnisse der Theorie und technologischer Prozesse bei der Herstellung von <b>Nanostrukturen</b> und <b>niedrigdimensionalen Systemen</b>.',
      'Praktisches Wissen und Problemlösung in den Bereichen <b>Laserphysik</b>, <b>Optoelektronik und Photonik</b> sowie Anwendungen der <b>Kernphysik</b>.',
      'Kenntnisse von Elementen der fortgeschrittenen <b>höheren Mathematik</b> in <b>Ingenieur- und Programmieranwendungen</b>.',
      'Grundkenntnisse in <b>Statistik und Datenanalyse</b> in <b>ROOT</b> und <b>Python</b>. Arbeiten mit den Bibliotheken <b>NumPy</b>, <b>Pandas</b> und <b>Matplotlib</b>.',
      'Grundlegende Fähigkeit zur Durchführung <b>numerischer</b> und symbolischer Berechnungen in <b>Mathematica</b> und <b>Python</b>.',
    ],
  },
  soft: {
    list: [
      'Leichtigkeit beim <b>Erwerb von Wissen</b>. Schnelles <b>Lernen</b>, <b>Flexibilität</b> und <b>Anpassungsfähigkeit</b> an Veränderungen.',
      'Fähigkeit im <b>Projektmanagement</b> und in der <b>Teamarbeit</b>. Erfahrung als Leiter und Teammitglied.',
      'Gute <b>Kommunikations-</b> und Organisations<b>fähigkeiten</b>. <b>Offenheit im Umgang</b> mit Menschen.',
      'Erfahrung in der Fachkommunikation auf <b>Englisch</b>, bestätigt durch die Teilnahme an wissenschaftlichen Konferenzen.',
      'Fähigkeit zum <b>logischen, kreativen und kritischen Denken</b>.',
    ],
  },
}
